import { AgTechClickEventHandler, useClickable } from '../Buttons/AgTechButtons';
import React, { CSSProperties, useRef } from 'react'
import { AgTechColorCombination } from '@agtech/core/styles/AgTechColors';

export type AgTechBadgeProps = AgTechBadgeConfigProps & {
    text: string,
};

export type AgTechBadgeConfigProps = {
    color?: AgTechColorCombination,
    classes?: string,
    onClickAction?: (e: AgTechClickEventHandler) => void
}

export const AgTechBadge = (props: AgTechBadgeProps) => {
    let agtechBadgeRef = useRef(null);
    let badgeClickable = useClickable(agtechBadgeRef);

    const badgeClickableClass = props.onClickAction ? 'clickable' : '';
    const badgeCustomClass = props.classes ?? '';

    let handleBadgeClick = (e: React.MouseEvent<HTMLElement>) => {
        if (props.onClickAction) {
            props.onClickAction({
                clickEvent: e,
                ...badgeClickable
            });
        }
    }

    let badgeStyles: CSSProperties = {};

    if (props.color) {
        badgeStyles.backgroundColor = props.color.backgroundColor;
        badgeStyles.borderColor = props.color.borderColor;
    }

    return (
        <div
            className={`py-[2px] px-3 shrink-0 font-no-wrap text-sm centered rounded border div ${badgeClickableClass} ${badgeCustomClass}`}
            onClick={handleBadgeClick}
            ref={agtechBadgeRef}
            style={badgeStyles}
        >
            {props.text}
        </div>
    )
};